import { useCallback, useState } from 'react';

import {
  defaultMonthlyRentPence,
  formatMonthlyRentPounds,
  parseMonthlyRentInput,
} from '@/pages/directory/utils/directory-fee-display';
import type { AreaFeeService } from '@/utils/fee-maths';

export type DirectoryFeeControlsState = {
  service: AreaFeeService;
  monthlyRentPence: number;
  isExampleRent: boolean;
  rentInput: string;
  setRentInput: (rawValue: string) => void;
  setService: (service: AreaFeeService) => void;
};

const useDirectoryFeeControls = (): DirectoryFeeControlsState => {
  const [service, setService] = useState<AreaFeeService>('management');
  const [rentInput, setRentInputState] = useState(() =>
    formatMonthlyRentPounds(defaultMonthlyRentPence),
  );
  const [isExampleRent, setIsExampleRent] = useState(true);

  const setRentInput = useCallback((rawValue: string) => {
    const cleaned = rawValue.replace(/\D/g, '').replace(/^0+/, '').slice(0, 6);
    setRentInputState(cleaned);
    setIsExampleRent(parseMonthlyRentInput(cleaned) == null);
  }, []);

  const enteredRentPence = parseMonthlyRentInput(rentInput);
  const monthlyRentPence = enteredRentPence ?? defaultMonthlyRentPence;

  return {
    service,
    monthlyRentPence,
    isExampleRent,
    rentInput,
    setRentInput,
    setService,
  };
};

export default useDirectoryFeeControls;
